// Computes a sliding window of page numbers centered on currentPage,
// clamped so it never runs past the first or last page.
export function getPaginationWindow(currentPage, totalPages, windowSize) {
  let windowStart = Math.max(1, currentPage - Math.floor(windowSize / 2));
  const windowEnd = Math.min(totalPages, windowStart + windowSize - 1);
  windowStart = Math.max(1, windowEnd - windowSize + 1);

  return Array.from(
    { length: windowEnd - windowStart + 1 },
    (_, i) => windowStart + i
  );
}
